<template>
  <div class="button-wrapper">
    <slot name="button-wrapper"></slot>
    <button
      v-if="$slots['icon-handler']"
      :ref="(el) => setRefButton(el)"
      class="button-mic"
      :class="{ red: hasNotification }"
      :is-open="isOpen"
      :data-off="isDataOff"
      @click="toggleButton"
    >
      <div class="icon-big icon-handler flex-center">
        <slot name="icon-handler"></slot>
      </div>
    </button>
    <div v-if="hintBoxText" class="mob-guide-speech" :class="{ close: !isVisibleHintBox }">
      <span>{{ hintBoxText }}</span>
      <button type="button" class="close-x" @click="closeHintBox">
        <IconX></IconX>
      </button>
    </div>
    <p class="smaller dim">{{ textButton }}</p>
  </div>
</template>

<script setup lang="ts">
import IconX from '@/components/icons/IconX.vue';

const props = withDefaults(
  defineProps<{
    isMic?: boolean; // 마이크 버튼인지
    isDataOff?: boolean; // data-off 여부
    isOpen?: boolean; // 드랍다운 오픈
    textButton?: string; // 아이콘 하단 문구
    hintBoxText?: string;
    onClick?: () => void; // 버튼 클릭 시 실행되는 함수
    setRefButton?: (el: HTMLElement) => void; // 버튼의 ref 설정을 위한 함수
    hasNotification?: boolean;
  }>(),
  {
    isMic: false,
    isDataOff: false,
    isOpen: false,
    textButton: '',
    hintBoxText: '',
    onClick: () => {},
    setRefButton: () => {},
    hasNotification: false,
  }
);

const isVisibleHintBox = ref<boolean>(false);

const toggleButton = () => {
  props.onClick();
  if (isVisibleHintBox.value) {
    closeHintBox();
  }
};

const closeHintBox = () => {
  isVisibleHintBox.value = false;
};

onMounted(() => {
  isVisibleHintBox.value = !!props.hintBoxText;
});
</script>

<style scoped lang="scss">
.button-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  text-align: center;
  white-space: nowrap;
  &:not(.lang-grd-mic) {
    .button-mic {
      width: 3rem;
    }
  }
}

.icon-handler {
  align-content: center;
  transition: fill 0.75s ease;
}

.icon-handler :deep(svg) {
  width: 100%;
  height: 100%;
}

p {
  min-height: 0.875rem;
}

.mob-guide-speech {
  position: absolute;
  background: $color-gray-700;
  display: none;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem 0.5rem 1rem;
  border-radius: 0.5rem;
  top: -2rem;
  right: -0.125rem;
  z-index: 10;
  opacity: 0;
  animation: fadeIn 0.5s ease-out 0.4s forwards;
  max-width: 180px;
  width: max-content;
  &::before {
    content: '';
    position: absolute;
    bottom: -6px;
    right: 1.75rem;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 7px 5px 0px 5px;
    border-color: $color-gray-700 transparent transparent transparent;
  }
  &.close {
    animation: fadeOut 0.4s ease-out forwards;
    .close-x {
      visibility: hidden;
    }
  }
  span {
    font-size: 0.75rem;
    color: #fff;
    word-break: keep-all;
    flex: 1;
    white-space: break-spaces;
    line-height: $line-height-psmaller;
  }
  .close-x {
    padding: 0.25rem;
    svg {
      color: $color-white;
    }
  }
}

@media (max-width: 768px) {
  .mob-guide-speech {
    display: flex;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(8px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(8px);
  }
}
</style>
